var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueWaterfall",staticClass:"vue-waterfall",class:_vm.isTransition&&'is-transition',style:({height:_vm.height}),attrs:{"id":"vueWaterfall"}},[_c('div',{staticClass:"slot-box"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dec9142","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vue-waterfall2@1.10.1@vue-waterfall2/waterfall.vue
// module id = null
// module chunks = 